<ng-container *transloco="let t; read: 'ime.components.action-bar'">
  <div class="d-flex" *ngIf="searchOptions.enabled">
    <div class="input-group input-group-sm my-auto d-print-none flex-nowrap">
      <input name="globalSearch" autocomplete="off" class="form-control" type="search" placeholder="{{t('Search')}}"
             [(ngModel)]="searchString"
             (ngModelChange)='searchText$.next(searchString);' (paste)="onPaste($event)">
      <button class="btn btn-outline-primary" *ngIf="searchOptions.advanced" type="button" (click)="toggleAdvanced()" [ngClass]="{'active': showFilters}">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#chevron-double-down"></svg>
      </button>
    </div>
    <help-button *transloco="let h" [key]="h('help.ime.general.search')"></help-button>
  </div>
</ng-container>
